// Home cartoon: cabeçalho que aparece depois da queda, o CZR que despenca com a rolagem, fotos que passam nos
// cartões da loja, contador de views pela média do canal e vídeos que só tocam na tela.
// Sem JS tudo aparece parado (cabeçalho visível, primeira foto, número base). Movimento reduzido: nada anda sozinho.
(() => {
  const reduzido = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const raiz = document.documentElement;

  // Cabeçalho: na home ele flutua escondido enquanto a abertura ocupa a tela
  const cab = document.querySelector('[data-cz-cab]');
  const heroi = document.querySelector('[data-cz-heroi]');
  if (cab && heroi && cab.classList.contains('cz-cab--flutua')) {
    const io = new IntersectionObserver(([e]) => cab.classList.toggle('cz-cab--escondido', e.isIntersecting), { threshold: 0.15 });
    io.observe(heroi);
  } else if (cab) cab.classList.remove('cz-cab--flutua');

  // O CZR cai mais rápido que a página: rolar empurra ele para baixo e para fora
  const queda = document.querySelector('[data-cz-queda]');
  if (queda && heroi && !reduzido) {
    // O Horizon rola dentro de .page-wrapper (html e body ficam com overflow hidden), não na janela
    const pw = document.querySelector('.page-wrapper');
    const rolador = pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null;
    const topo = () => (rolador ? rolador.scrollTop : window.scrollY);
    let pedido = 0;
    const mover = () => {
      pedido = 0;
      const h = heroi.offsetHeight, y = Math.min(topo(), h);
      const k = y / h;
      queda.style.transform = `translateY(${(y * 0.75).toFixed(1)}px) rotate(${(k * 18).toFixed(2)}deg) scale(${(1 - k * 0.25).toFixed(3)})`;
    };
    (rolador || window).addEventListener('scroll', () => { if (!pedido) pedido = requestAnimationFrame(mover); }, { passive: true });
    mover();
  }

  // Cartões da loja: troca de foto a cada 2,6 s quando o cartão está na tela; os pontinhos escolhem a foto
  const cartoes = [...document.querySelectorAll('[data-cz-fotos]')];
  if (cartoes.length) raiz.classList.add('cz-fotos-vivas');
  cartoes.forEach((c, n) => {
    const fotos = [...c.querySelectorAll('.cz-produto__fotos img')];
    const pontos = [...c.querySelectorAll('.cz-pontos button')];
    let atual = 0, timer = 0, visivel = false;
    const mostrar = (i) => {
      fotos[atual]?.classList.remove('cz-ativa'); pontos[atual]?.setAttribute('aria-current', 'false');
      atual = (i + fotos.length) % fotos.length;
      const f = fotos[atual];
      if (f && f.loading === 'lazy') f.loading = 'eager';
      f?.classList.add('cz-ativa'); pontos[atual]?.setAttribute('aria-current', 'true');
    };
    pontos.forEach((p, i) => p.addEventListener('click', (ev) => { ev.preventDefault(); mostrar(i); }));
    if (reduzido || fotos.length < 2) return;
    const tocar = () => { clearInterval(timer); if (visivel && !document.hidden) timer = setInterval(() => mostrar(atual + 1), 2600); };
    setTimeout(() => new IntersectionObserver(([e]) => { visivel = e.isIntersecting; tocar(); }, { threshold: 0.4 }).observe(c), n * 450);
    document.addEventListener('visibilitychange', tocar);
  });

  // Cartão único: uma foto por cor, começando no preto; o ponto escolhido manda na etiqueta, no prazo e na compra
  if (document.querySelector('[data-cz-cores]')) raiz.classList.add('cz-fotos-vivas');
  document.querySelectorAll('[data-cz-cores]').forEach((c, n) => {
    const fotos = [...c.querySelectorAll('.cz-produto__fotos img')];
    const pontos = [...c.querySelectorAll('.cz-cores__ponto')];
    const nome = c.querySelector('[data-cz-nome]'), tom = c.querySelector('[data-cz-tom]'), prazo = c.querySelector('[data-cz-prazo]');
    const id = c.querySelector('[data-cz-id]'), comprar = c.querySelector('[data-cz-comprar]'), link = c.querySelector('[data-cz-link]');
    let atual = 0, timer = 0, visivel = false;
    const mostrar = (i) => {
      fotos[atual]?.classList.remove('cz-ativa');
      atual = (i + pontos.length) % pontos.length;
      const p = pontos[atual], f = fotos[atual];
      if (f && f.loading === 'lazy') f.loading = 'eager';
      f?.classList.add('cz-ativa');
      pontos.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
      nome.textContent = p.dataset.nome; tom.style.setProperty('--cor', p.dataset.tom); prazo.textContent = p.dataset.prazo;
      id.value = p.dataset.variante; link.href = p.dataset.url;
      const livre = p.dataset.disponivel === 'true';
      comprar.disabled = !livre; comprar.textContent = livre ? 'Comprar' : 'Esgotado';
    };
    mostrar(0);
    pontos.forEach((p, i) => p.addEventListener('click', () => { mostrar(i); clearInterval(timer); }));
    if (reduzido || pontos.length < 2) return;
    const tocar = () => { clearInterval(timer); if (visivel && !document.hidden) timer = setInterval(() => mostrar(atual + 1), 2200); };
    new IntersectionObserver(([e]) => { visivel = e.isIntersecting; tocar(); }, { threshold: 0.4 }).observe(c);
    document.addEventListener('visibilitychange', tocar);
  });

  // Views: base real + ritmo médio do canal desde a data da base. O número é o mesmo para todo mundo na mesma hora.
  const views = document.querySelector('[data-cz-views]');
  if (views) {
    const base = Number(views.dataset.base), desde = Date.parse(views.dataset.desde), ritmo = Number(views.dataset.ritmo);
    const mais = views.parentElement.querySelector('.cz-contador__mais');
    const fmt = (x) => Math.round(x).toLocaleString('pt-BR');
    const agora = () => base + Math.max(0, (Date.now() - desde) / 1000) * ritmo;
    let mostrado = agora();
    views.textContent = fmt(mostrado);
    if (!reduzido && Number.isFinite(desde)) {
      // Intervalo sorteado entre 1,6 e 16 s: o salto varia de ~40 a ~400 sem sair da média
      const tique = () => setTimeout(() => { subir(); tique(); }, 1600 + Math.random() * 14400);
      const subir = () => {
        if (document.hidden) return;
        const alvo = agora(), de = mostrado, t0 = performance.now();
        if (alvo - de < 1) return;
        if (mais) { mais.textContent = '+' + fmt(alvo - de); mais.classList.add('cz-vivo'); setTimeout(() => mais.classList.remove('cz-vivo'), 1600); }
        const passo = (t) => {
          const k = Math.min(1, (t - t0) / 900);
          mostrado = de + (alvo - de) * (1 - Math.pow(1 - k, 3));
          views.textContent = fmt(mostrado);
          if (k < 1) requestAnimationFrame(passo);
        };
        requestAnimationFrame(passo);
      };
      tique();
    }
  }

  // Vídeos: carregam e tocam só quando aparecem
  const videos = document.querySelectorAll('video[data-cz-video]');
  if (reduzido) videos.forEach((v) => { v.controls = true; });
  else {
    const iv = new IntersectionObserver((itens) => {
      for (const it of itens) {
        const v = it.target;
        if (it.isIntersecting) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } v.play().catch(() => {}); }
        else v.pause();
      }
    }, { threshold: 0.35 });
    videos.forEach((v) => iv.observe(v));
  }
})();
